import SystemFieldProto from '../../../proto/system-field-proto';
import ListComponent from './components/list-view';
import ViewComponent from '../components/total-view';
import AggregateTotalComponent from "../components/aggregate-total";
import FieldShortTextViewInImport from "../../../import/view-in-preview/short-text-in-preview";
import AggregateNumber from "../../../aggregate/aggregate-number";

export default class AttachmentsTotalField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.ATTACHMENTS_TOTAL;
    }

    get sortHintMessage() {
        return 'Sort by # attachments';
    }

    getCsvValue(item) {
        if (!item.attachmentsTotal) return null;
        return item.attachmentsTotal;
    }

    getValue(item) {return item.attachmentsTotal}

    getAggregateClass() {return AggregateNumber}
    getAggregateOptions() {return [
        gd.const.aggregate.type.SUM,
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.AVERAGE
    ]}

    listItemSortFunctions(sort) {
        return {
            functions: [i => i.item.attachmentsTotal ? i.item.attachmentsTotal : 0], //somehow momentClosed could be undefined
            directions: [sort]
        }
    }

    get ListComponent() {return ListComponent.bind(null);}
    get ViewComponent() {return ViewComponent.bind(null);}
    get AggregateComponent() {return AggregateTotalComponent.bind(null, this.getAggregateOptions())}

    // IMPORT

    normalizeCSVValue(value) {
        return value ? value.trim() : null;
    }

    getComponentViewInImport() {
        return FieldShortTextViewInImport;
    }
}
